import React from 'react';
import { Space, Select, Typography } from 'antd';
import ClipboardCopyButton from '../../ClipboardCopyButton';
import SyntaxHighlighter from '../SyntaxHighlighter/SyntaxHighlighter';
import './requestCodeSection.css';

const { Text } = Typography;

/**
 * RequestCodeSection - Reusable component for displaying request code
 * Shows the generated request in different formats (cURL, Fetch, etc.)
 *
 * @param {string} request - The generated request code string
 * @param {string} requestFormat - Current format (e.g., 'curl', 'fetch')
 * @param {Function} setRequestFormat - Function to change the format
 * @param {Array} formats - Array of format options (optional)
 */
const RequestCodeSection = ({
  request,
  requestFormat,
  setRequestFormat,
  formats = [
    {
      value: 'curl',
      label: (
        <Space size={8}>
          <span className="format-icon">{'</>'}</span>
          <span>cURL</span>
        </Space>
      ),
    },
    {
      value: 'fetch',
      label: (
        <Space size={8}>
          <span className="format-icon">{'{ }'}</span>
          <span>Fetch</span>
        </Space>
      ),
    },
  ],
}) => {
  return (
    <div className="code-section request-code-section">
      <div className="code-section-header">
        <Text className="section-title">Request</Text>
        <Space size={4}>
          <Select
            value={requestFormat}
            onChange={setRequestFormat}
            size="small"
            className="format-selector-dropdown"
            suffixIcon={<span className="dropdown-arrow">▼</span>}
            popupClassName="format-dropdown-menu"
            dropdownMatchSelectWidth={false}
            options={formats}
          />
          <ClipboardCopyButton data={request} toolTipText="Copy" />
        </Space>
      </div>
      <div className="code-section-body">
        <SyntaxHighlighter code={request} language={requestFormat} />
      </div>
    </div>
  );
};

export default RequestCodeSection;
